function roundOff(value, precision) {
  return parseFloat(value).toFixed(precision);
}

const NumberFormatHelper = {
  roundOff,
};

export default NumberFormatHelper;
